import Search from './container'

export default Search